// @ts-nocheck
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  convertSecondsToTime,
  daysToSeconds,
  hoursToSeconds,
  minutesToSeconds,
} from '@lbca-shared/helpers/converter';
import { DatePickerCondensedComponent } from '../date-picker-condensed/date-picker-condensed.component';
import { TimepickerCondensedComponent } from '../timepicker-condensed/timepicker-condensed.component';

@Component({
  selector: 'lbca-date-time-picker-condensed',
  templateUrl: './date-time-picker-condensed.component.html',
  styleUrl: './date-time-picker-condensed.component.scss',
  imports: [DatePickerCondensedComponent, TimepickerCondensedComponent],
})
export class DateTimePickerCondensedComponent {
  public errorDate: Array<string> = [];
  public errorTime: Array<string> = [];
  public labelDateValue: string = '';
  public labelTimeValue: string = '';
  public helperTextValue: string = '';
  public isRequired: boolean = false;
  public isLabeled: boolean = true;
  public isEditable: boolean = false;
  public isDisabled: boolean = false;
  public isTabeled: boolean = false;
  public valueInput: any = null;

  @Input('error') set err(error) {
    this.errorDate = error
      .filter((err) => err?.field === 'date-picker' || err.field === undefined)
      .map((err) => err?.message ?? err);
    this.errorTime = error
      .filter((err) => err?.field === 'time-picker' || err.field === undefined)
      .map((err) => err?.message ?? err);
  }

  @Input() set value(val: string) {
    this.valueInput = val as unknown as number;
  }
  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }
  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set labelDate(value: string) {
    this.labelDateValue = value;
  }
  @Input() set labelTime(value: string) {
    this.labelTimeValue = value;
  }
  @Input() rules: Array<any> = [];

  @Output('changeValue') changeEmmiter = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();

  @Output() focusState = new EventEmitter();

  @Output('validStatus') validStatusEmmiter = new EventEmitter();

  constructor() {}

  public setFocus(focus): void {
    this.focusState.emit(focus);
  }

  public setValid(valid): void {
    this.validStatusEmmiter.emit(valid);
  }

  public changeDate($event) {
    const valueInput = this.valueInput || $event;
    const threeHours = hoursToSeconds(3);
    const oneDay = daysToSeconds(1);

    this.valueInput = $event + ((valueInput - threeHours) % oneDay);

    this.changeEmmiter.emit(this.valueInput);
  }

  public changeTime($event) {
    const valueInput = this.valueInput || 0;
    const threeHours = hoursToSeconds(3);
    const oneDay = daysToSeconds(1);

    const [hour, minute] = $event.split(':');

    const hours = hoursToSeconds(hour);
    const minutes = minutesToSeconds(minute);
    const startDate = valueInput - ((valueInput - threeHours) % oneDay);

    this.valueInput = startDate + hours + minutes;

    this.changeEmmiter.emit(this.valueInput);
    this.setErrorEmmiter.emit([]);
  }

  public setErrorFn($event) {
    this.setErrorEmmiter.emit($event);
  }

  public formatToTimePiker(timestamp: number): string {
    if (!timestamp) return '';

    const threeHours = hoursToSeconds(3);
    const oneDay = daysToSeconds(1);

    const timeInSeconds = (timestamp - threeHours) % oneDay;

    return convertSecondsToTime(timeInSeconds);
  }
}
